import clsx from "clsx";
import { useEffect } from "react";

import useSizes from "@/lib/centra/hooks/useSizes";
import { useProductContext } from "../../ProductProvider";
import styles from "./index.module.css";

function getLabel(name: string) {
  switch (name) {
    case "Small":
      return "S";
    case "Medium":
      return "M";
    case "Large":
      return "L";
    case "X-Large":
      return "XL";
    default:
      return name;
  }
}

const SizeSelector = () => {
  const { activeVariant } = useProductContext();
  const sizes = useSizes(activeVariant?.sizes);

  useEffect(() => {
    if (sizes?.sizes?.length === 1 && sizes?.sizes[0].isSelected) return;
    if (sizes?.sizes?.length === 1) {
      sizes.sizes[0].selectSize();
    }
  }, [sizes]);

  if (!sizes || !sizes.sizes || sizes?.sizes?.length === 1) return null;
  let specialSize = false;
  sizes.sizes.forEach((size) => {
    if (getLabel(size.name).length > 3) {
      specialSize = true;
    }
  });

  return (
    <div className={styles.sizes__container}>
      <span className={styles.sizeLabel}>Size</span>
      <div className={styles.sizes__wrapper}>
        <div className={clsx(styles.sizes, specialSize && styles.specialSize)}>
          {sizes?.sizes.map((size) => {
            return (
              <span className={styles.buttonWrapper} key={size.itemId}>
                <button
                  key={`${size.itemId}-size`}
                  className={clsx(
                    styles.size,
                    size.isSelected && styles.selected,
                    !size.stock && styles.inactive,
                  )}
                  onClick={() => size.selectSize(true)}
                >
                  {getLabel(size.name)}
                </button>
              </span>
            );
          })}
        </div>
      </div>

      {sizes.selectedSize && (
        <p>
          {sizes.selectedSize?.fewLeft && (
            <span className={styles["few-left"]}>
              Only a few left in this size
            </span>
          )}
        </p>
      )}
    </div>
  );
};

export default SizeSelector;
